export function filterTrendRows(rows = [], selections = {}) {
  const {
    locations = [], providers = [], products = [], categories = [], fuelTypes = [],
  } = selections;
  const hasProductScope = products.length > 0 || categories.length > 0 || fuelTypes.length > 0;
  if (!hasProductScope) return [];

  return rows.filter((row) =>
    locations.includes(row.locationKey || row.locationName || row.location) &&
    providers.includes(row.provider) &&
    (products.length === 0 || products.includes(row.productName)) &&
    (categories.length === 0 || (row.categoryId && categories.includes(row.categoryId))) &&
    (fuelTypes.length === 0 || (row.fuelTypeId && fuelTypes.includes(row.fuelTypeId)))
  );
}
